// export.ts — CSV export of the meal + weight log (all local; nothing leaves the device).

import type { Meal, WeightEntry } from "./store";
import { SOURCE_LABELS } from "./store";

function cell(v: string | number): string {
  const s = String(v ?? "");
  return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
}
function csv(headers: string[], rows: (string | number)[][]): string {
  return [headers, ...rows].map((r) => r.map(cell).join(",")).join("\n");
}

/** Meals CSV: Date, Meal, Calories (est.), Protein g, Carbs g, Fat g, Source, Note. */
export function mealsCsv(meals: Meal[]): string {
  return csv(
    ["Date", "Meal", "Calories (est. kcal)", "Protein g", "Carbs g", "Fat g", "Source", "Note"],
    meals.map((m) => [
      m.eaten_on,
      m.name,
      m.calories,
      m.protein_g ?? "",
      m.carbs_g ?? "",
      m.fat_g ?? "",
      SOURCE_LABELS[m.source] ?? m.source,
      m.note ?? "",
    ]),
  );
}

/** Weights CSV appended below the meals block. */
export function weightsCsv(weights: WeightEntry[]): string {
  return csv(
    ["Date", "Weight kg", "Note"],
    weights.map((w) => [w.measured_on, w.weight_kg, w.note ?? ""]),
  );
}

export function buildExport(meals: Meal[], weights: WeightEntry[]): { csv: string; filename: string } {
  const stamp = new Date().toISOString().slice(0, 10);
  const parts = [mealsCsv(meals)];
  if (weights.length > 0) parts.push("", "WEIGHT LOG", weightsCsv(weights));
  return { csv: parts.join("\n"), filename: `health-tracker-${stamp}.csv` };
}
